import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { ICellRendererParams } from '@ag-grid-community/core';
import { DownloadIcon } from '@urc-ui/components/icons/download-icon';
import { getEntityId } from '@urc-ui/store/api/base';
import { isADSPReportCenterEnabled } from '@urc-ui/utils/app-utils';
import { getBaseurl } from '@urc-ui/utils/url-utils';
import { StyledCellWrapper, StyledLink } from '@urc-ui/components/styles';
import { TAKT_EVENT, TAKT_EVENT_SOURCE, useTaktLogger } from '@urc-ui/hooks/takt-logger';

const NameContainer = styled.div`
  display: inline-block;
`;

const DownloadContainer = styled.div`
  display: inline-block;
  float: right;
`;

const NameWithDownloadCellRenderer = (props: ICellRendererParams) => {
  const subscription = props.value.subscription;
  const { search } = useLocation();
  const { logCustomTaktEvent } = useTaktLogger({ subscription });

  const onReportNameClick = () =>
    logCustomTaktEvent({ eventName: TAKT_EVENT.OPEN_REPORT_DETAILS, source: TAKT_EVENT_SOURCE.SUBSCRIPTION_TABLE });

  const onDownloadIconClick = () =>
    logCustomTaktEvent({ eventName: TAKT_EVENT.DOWNLOAD_REPORT, source: TAKT_EVENT_SOURCE.SUBSCRIPTION_TABLE });

  let url = `/history/${subscription.id}${search}`;
  if (isADSPReportCenterEnabled()) {
    url = `${getBaseurl()}/dsp/${getEntityId()}/report/report-center/${subscription.id}/history`;
  }

  if (!subscription || !subscription.id) {
    return null;
  }

  return (
    <div data-cy='reportName'>
      <StyledCellWrapper>
        <NameContainer>
          <StyledLink to={url} onClick={onReportNameClick}>
            {subscription.name}
          </StyledLink>
        </NameContainer>
        <DownloadContainer>
          <DownloadIcon url={subscription.s3Url} onClick={onDownloadIconClick} />
        </DownloadContainer>
      </StyledCellWrapper>
    </div>
  );
};

export { NameWithDownloadCellRenderer };
